import React, { lazy, Suspense } from 'react';
import { Button, Drawer, Flex, Modal } from 'antd';
import { useTranslate } from '@refinedev/core';
import Loading from 'components/loading/loading';

const RuleChangeGroupForm = lazy(
  () => import('pages/ruleChange/ruleGroup/RuleGroupForm')
);
const RuleChangeGroupView = lazy(
  () => import('pages/ruleChange/ruleGroup/RuleGroupView')
);

const RuleGroupModals = ({
  groupModal,
  createGroupDrawer,
  reArrangeModal,
  activeGroup,
  activeGroupRecord,
  confirmReorder,
  cancelReorder,
  refetch,
  pageType,
  isPublished,
  ruleListRefetch,
}) => {
  const t = useTranslate();

  return (
    <>
      {/* Group show/edit drawer */}
      <Drawer
        title={
          <div>
            <div>
              {activeGroup?.mode === 'Show'
                ? t('ruleGroup.ruleGroupDetails')
                : `${activeGroup?.id ? t('actions.edit') : t('actions.create')} ${t('ruleGroup.ruleGroupTitle')}`}
            </div>
            <div className="text-sm font-normal text-neutral-100">
              {activeGroupRecord?.rule_group_name}
            </div>
          </div>
        }
        width="70%"
        open={groupModal.modalProps.open}
        onClose={() => groupModal.close()}
        destroyOnClose
        maskClosable={false}
        footer={
          activeGroup?.mode !== 'Show' ? (
            <Flex justify="end" gap={8}>
              <Button onClick={() => groupModal.close()}>
                {t('buttons.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                form="rule-change-group-form"
              >
                {t('buttons.saveRuleGrp')}
              </Button>
            </Flex>
          ) : (
            <Flex justify="end">
              <Button onClick={() => groupModal.close()}>
                {t('buttons.close')}
              </Button>
            </Flex>
          )
        }
      >
        <Suspense fallback={<Loading />}>
          {activeGroup?.mode === 'Show' ? (
            <RuleChangeGroupView
              // key={activeGroup?.id}
              group={activeGroupRecord}
              pageType={pageType}
              isPublished={isPublished}
            />
          ) : (
            <RuleChangeGroupForm
              key={`${activeGroup?.id}-${activeGroup?.mode}`}
              id={activeGroup?.id}
              mode={activeGroup?.mode}
              onDone={() => {
                groupModal.close();
                refetch();
                Object.values(ruleListRefetch).forEach((fn: any) => fn?.());
              }}
            />
          )}
        </Suspense>
      </Drawer>

      <Drawer
        title={t('rules.createGroup')}
        width="85%"
        maskClosable={false}
        open={createGroupDrawer.modalProps.open}
        onClose={() => createGroupDrawer.close()}
        destroyOnClose
        footer={
          <Flex justify="end" gap={8}>
            <Button onClick={() => createGroupDrawer.close()}>
              {t('buttons.cancel')}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              form="rule-change-group-form"
            >
              {t('buttons.saveRuleGrp')}
            </Button>
          </Flex>
        }
      >
        <Suspense fallback={<Loading />}>
          <RuleChangeGroupForm
            id={undefined}
            mode="Create"
            onDone={() => {
              createGroupDrawer.close();
              refetch();
            }}
          />
        </Suspense>
      </Drawer>

      <Modal
        title=""
        open={reArrangeModal.modalProps.open}
        onOk={confirmReorder}
        onCancel={cancelReorder}
        maskClosable={false}
      >
        <div>{t('rules.messages.ruleDesc')}</div>
      </Modal>
    </>
  );
};

export default RuleGroupModals;
